import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import Head from '../../components/Partials/Head/Head';
import Auxiliary from '../../hoc/Auxiliary';
import TextGroup from '../../components/TextGroup/TextGroup';
import ProductBanner from '../../components/ProductBanner/ProductBanner';
import ProductSection from '../../components/ProductSection/ProductSection';

class Facilities extends Component {
    render() {
        return (
            <Auxiliary>
                <Head {...this.props} id="facilities" />
                <ProductBanner imgPadding {...this.props} page="facilities" />
                <ProductSection noPadBottom {...this.props} facilities page="facilities" section="features">
                    <TextGroup {...this.props} page="facilities" section="features" />
                </ProductSection>
                <ProductSection {...this.props} facilities page="facilities" section="functionalities">
                    <TextGroup {...this.props} page="facilities" section="functionalities" />
                    <TextGroup noPadBottom {...this.props} page="facilities" section="demo" />
                </ProductSection>
            </Auxiliary>
        )
    }
}

export default withTranslation()(Facilities);